export var applyEventProps = function (props) { return ({
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onMouseLeave: props.onMouseLeave,
    onMouseOver: props.onMouseOver,
    onTouchEnd: props.onTouchEnd,
    onTouchStart: props.onTouchStart,
}); };
